import { Center, Container, Grid, Heading } from '@chakra-ui/react';
import { ReactElement } from 'react';

function HomePage() {

    return (
        <div>
            <h1>Home</h1>
        </div>
    )
}

export default HomePage;
